class mGtmEvent extends window.HTMLInputElement {
    constructor() {
        super();
        this.data = this.value;
        this.pushEvent = this.pushEvent.bind(this);
    }

    pushEvent() {
        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
            detail: {
                data: JSON.parse(this.data)
            }
        }));
    }

    connectedCallback() {
        this.type = 'hidden';
        this.pushEvent();
    }
}

customElements.define('m-gtm-event', mGtmEvent, {
    extends: 'input'
});
